<template>
  <div>
    <div class="row" >
      <div class="col-md-12">
        <h2>Project: <code class="text-center text-warning">{{projectName}}</code></h2>
      </div>
    </div>
    <div class="row">
      <div v-if="years.length > 1" class="col-12">
        <year-selector :years="years" :selected="selectedYear" @change="changeYear" />
      </div>
    </div>
    <div class="row" >
      <div v-if="selectedIncomes" class="col-md-12">
        <incomes-report-total :totalPerArticles="selectedTotalPerArticles" :totalAmount="selectedTotalAmount"></incomes-report-total>
      </div>
    </div>
    <div class="row" >
      <div v-if="selectedIncomes" class="col-md-12">
        <incomes-report :incomes="selectedIncomes" :totalAmount="selectedTotalAmount" @export-to-excel="exportToExcel(projectId)"></incomes-report>
      </div>
    </div>
  </div>
</template>

<script>
    import NotificationTemplate from "../Notifications/NotificationTemplate";
    import axios from "axios";
    import {setCookie, url, hosting} from "../../plugins/axios";
    import IncomesReportTotal from "../Reports/IncomesReportTotal";
    import IncomesReport from "../Reports/IncomesReport";
    import YearSelector from "@/components/YearSelector";

    export default {
      name: "ProjectsReports",
      components: {IncomesReport, IncomesReportTotal, YearSelector},
      data(){
        return{
          projectName: '',
          projectId: 0,

          incomes: [],
          totalAmount: {},
          totalPerArticles: {},

          years: [],
          selectedYear: '',
          selectedIncomes: [],
          selectedTotalAmount: 0,
          selectedTotalPerArticles: {},
        }
      },
      watch: {
        selectedYear() {
          this.setTableData();
        }
      },
      methods:{
        notifyVue(type,message) {
          this.$notify({
            component: NotificationTemplate,
            icon: "tim-icons icon-bell-55",
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: type,
            message:message,
            timeout: 1500
          });
        },
        getProjectReport(id){
          axios
            .get(url + 'projects-reports/'+id+'/',
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error === ''){
                if (response.data.result !== null){
                  const temp = response.data.result;
                  this.incomes = temp[Object.keys(temp)[0]];
                  this.createTable(this.incomes);
                }
              }
              else{
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                }
              }
            })
            .catch((error) => {
              this.notifyVue('danger',error);
            });
        },
        createTable(data) {
          const temp = {};
          Object.keys(data).forEach((key) => {
            if (data[key]['date_of_adding']) {
              let year = data[key]['date_of_adding'].split('-')[0];
              year = parseInt(year);

              if (!this.years.includes(year)) {
                this.years.push(year);
                temp[year] = {};
                this.totalPerArticles[year] = {};
                this.totalAmount[year] = 0;
              }
              const article = key.split('_')[0];
              if (!this.totalPerArticles[year][article]) {
                this.totalPerArticles[year][article] = 0;
              }
              const amount = parseInt(data[key]['amount']);
              this.totalPerArticles[year][article] += amount;
              this.totalAmount[year] += amount;
              temp[year][key] = data[key];
            }
          });
          this.incomes = temp;
          this.selectedYear = Math.max(...this.years);
          this.setTableData();
        },
        setTableData(){
          this.selectedIncomes = this.incomes[this.selectedYear];
          this.selectedTotalAmount = this.totalAmount[this.selectedYear];
          this.selectedTotalPerArticles = this.totalPerArticles[this.selectedYear];
        },
        changeYear(year) {
          this.selectedYear = year
        },
        exportToExcel(id){
          axios
            .get(url + 'projects-reports/excel/'+id+'/'+this.selectedYear,
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error === ''){
                let path = response.data.result;
                path = path.split('href="')[0] + 'href="' + hosting + path.split('href="')[1];
                let $link = $(path);
                $("body").append($link);
                document.getElementById('getReport').click();
                $("#getReport").remove();
              }
              else{
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                }
              }
            })
        },
      },
      created() {
        const params = this.$route.query;
        this.projectName = params.projectName.split('_').join(' ');
        if (params.projectId > 0){
          this.projectId = params.projectId;
          this.getProjectReport(params.projectId);
        }
      },
    }
</script>

<style scoped>

</style>
